<template>
	<div class="load-betslip">
		<span v-show="loading">{{ this.$t("general.loading") }}...</span>
		<loader v-show="loading" :dark="true" />
		<div v-if="!loading">
			<p class="load-betslip__desc">
				{{ this.$t("betslip.enter-shared-betslip-code") }}
			</p>
			<div class="load-betslip__sharing-code">
				<input
					class="load-betslip__sharing-code__input"
					type="text"
					name="sharing-code"
					v-model="shareCode"
					:disabled="loading"
					:placeholder="$t('general.eg') + ' VBmSU'"
				/>
				<span class="error" v-show="errorMessage">{{ errorMessage }}</span>

				<b-button
					class="button button__secondary share-code-button"
					:disabled="loading"
					:title="this.$t('betslip.load-betslip')"
					@click="getCodeMatches()"
				>
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "load-betslip",
	props: {
		injectedCode: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			shareCode: null,
			errorMessage: null,
			loading: false,
		};
	},
	created() {
		if (this.injectedCode) {
			this.shareCode = this.injectedCode;
			this.getCodeMatches();
		}
	},
	methods: {
		getCodeMatches() {
			let vm = this;
			vm.loading = true;
			if (!vm.shareCode) {
				vm.errorMessage = "Please enter a code";
				vm.loading = false;
				return;
			}
			vm.$axios
				.get(`${BASE_V2_URL}share/decode?code=${vm.shareCode}&src=MOBILE_WEB`)
				.then((response) => {
					let { data, meta, message } = response.data;
					if (data.length == 0) return;
					if (meta.product_type == "SHIKISHA") {
						vm.$store.commit("clearJengabetBetslip");
					} else if (
						meta.product_type == "15M_JACKPOT" ||
						meta.product_type == "100M_JACKPOT" ||
						meta.product_type == "BOOSTED_MULTIBET"
					) {
						let jackpotToClear = {
							id: meta.jackpot[0].jackpot_event_id,
							event_name: meta.jackpot[0].jackpot_name,
							status: meta.jackpot[0].status,
							event_expiry: meta.jackpot[0].expiry,
							total_games: meta.jackpot[0].total_games,
							product_id: meta.jackpot[0].product_id,
							max_combinations: meta.jackpot[0].max_combinations,
							details: [],
						};
						if (meta.product_type == "BOOSTED_MULTIBET") {
							vm.$store.commit("boostedMultibet/clear", jackpotToClear);
						} else {
							vm.$store.commit("weeklyJackpot/clear", jackpotToClear);
						}
					} else {
						vm.$store.commit("clearBetslip");
					}

					data.forEach((match) => {
						if (meta.product_type == "SHIKISHA") {
							vm.addToShikishaBetslip(match, meta);
						} else if (
							meta.product_type == "15M_JACKPOT" ||
							meta.product_type == "100M_JACKPOT" ||
							meta.product_type == "BOOSTED_MULTIBET"
						) {
							console.log("Load jackpots betslip ===>", data);
							vm.addToJackpotBetslip(
								match,
								meta,
								meta.product_type == "BOOSTED_MULTIBET"
							);
						} else {
							vm.addToBetslip(match, meta);
						}
					});

					vm.$store.commit("toggleSnackBar", {
						show: true,
						messages: [message],
						status: "success",
					});
					setTimeout(() => {
						vm.$store.commit("toggleSnackBar", {
							show: false,
							messages: [""],
						});
					}, 3000);
					vm.addRegistrationTag(meta.code);
					if (meta.product_type == "SHIKISHA") {
						vm.$router.replace("/betslip?type=shikisha");
					} else if (meta.product_type == "100M_JACKPOT") {
						vm.$router.replace("/jackpots");
					} else if (meta.product_type == "15M_JACKPOT") {
						vm.$router.replace("/jackpots/midweekjp");
					} else if (meta.product_type == "BOOSTED_MULTIBET") {
						let jackpotId = meta.jackpot[0].jackpot_event_id;
						vm.$router.replace({
							name: "boosted-multibet-event",
							params: { id: jackpotId },
						});
					} else {
						vm.$router.replace("/betslip");
					}
					vm.loading = false;
				})
				.catch((error) => {
					vm.loading = false;
					if (error.response) vm.errorMessage = error.response.data.message;
					else vm.errorMessage = "An error occured. Please try again.";
				});
		},
		addToBetslip(match, meta) {
			var vm = this;
			if (!Number(match.odd_value)) return;
			let odd = {
				display: match.odd_key,
				odd_key: match.odd_key,
				odd_value: match.odd_value,
				outcome_id: match.outcome_id,
				special_bet_value: match.special_bet_value || "",
				parent_match_id: match.parent_match_id,
				sport_id: match.sport_id,
			};
			let bet = {
				matchId: match.match_id,
				odd,
				type: match.sub_type_id,
				market: match.name,
				display: `${match.home_team} vs. ${match.away_team}`,
				startTime: match.start_time,
				live: match.live,
				active: true,
				is_shared: true,
				share_code: meta["code"],

				// Coola payload
				parent_match_id: match.parent_match_id,
				game_description: `${match.home_team} vs. ${match.away_team}`,
				bet_pick: match.odd_key,
				sub_type_id: match.sub_type_id,
				market_name: match.market_name,
				odd_key: match.odd_key,
				odd_value: match.odd_value,
				special_bet_value: match.special_bet_value || "",
				bet_type: match.live > 0 ? "live" : "pre_match",
				home_team: match.home_team,
				away_team: match.away_team,
				sport_id: match.sport_id,
			};
			// then add the new odd to the betslip
			vm.$store.commit("addToBetslip", bet);
		},
		addToJackpotBetslip(jackpotMatch, meta, isBoostedMultibet) {
			let vm = this;

			let matchToAdd = {
				sport_id: jackpotMatch[0].sport_id,
				sport_name: jackpotMatch[0].sport_name,
				match_id: jackpotMatch[0].match_id,
				game_id: jackpotMatch[0].game_id,
				start_time: jackpotMatch[0].start_time,
				home_team: jackpotMatch[0].home_team,
				away_team: jackpotMatch[0].away_team,
				parent_match_id: jackpotMatch[0].parent_match_id,
				odds: [],
			};
			if (!isBoostedMultibet) {
				matchToAdd.jackpot_event_id = meta.jackpot[0].jackpot_event_id;
			} else {
				matchToAdd.boosted_multibet_event_id = meta.jackpot[0].jackpot_event_id;
			}

			let oddToAdd = this.formatOdd(jackpotMatch[0]);

			let bet = {
				id: meta.jackpot[0].jackpot_event_id,
				match: matchToAdd,
				odd: oddToAdd,
			};

			console.log("Bet to Add", bet);

			if (isBoostedMultibet == true) {
				vm.$store.commit("boostedMultibet/addToBetslip", bet);
			} else {
				vm.$store.commit("weeklyJackpot/addToBetslip", bet);
			}

			if (jackpotMatch.length > 1 && isBoostedMultibet == false) {
				let oddsArray = jackpotMatch.slice(1);
				oddsArray.forEach((match) => {
					let selectedOddsObject = {
						id: meta.jackpot[0].jackpot_event_id,
						match: { parent_match_id: match.parent_match_id },
						odd: this.formatOdd(match),
					};
					vm.$store.commit(
						"weeklyJackpot/updateSelectedOdds",
						selectedOddsObject
					);
				});
			} else {
				let selectedOddsObject = {
					id: meta.jackpot[0].jackpot_event_id,
					match: { parent_match_id: jackpotMatch[0].parent_match_id },
					odd: oddToAdd,
				};
				vm.$store.commit(
					"weeklyJackpot/updateSelectedOdds",
					selectedOddsObject
				);
			}
		},
		formatOdd(match) {
			let odd = {
				sub_type_id: match.sub_type_id,
				name: match.name,
				odd_key: match.odd_key,
				odd_def: match.odd_def,
				odd_value: match.odd_value,
				special_bet_value: match.special_bet_value,
				outcome_id: match.outcome_id,
				combination_factor: match.combination_factor || 1,
				winning_outcome: null,
				winning_outcome_id: null,
			};
			if (match.outcome_id == "1") {
				match.display = "1";
			} else if (match.outcome_id == "2") {
				match.display = "X";
			}
			if (match.outcome_id == "3") {
				match.display = "2";
			}
			return odd;
		},

		addRegistrationTag(code) {
			let days = 7;
			this.$cookie.set("share_code", code, days);
			this.$cookie.set("login_share_code", code, 1);
		},
		addToShikishaBetslip(match, meta) {
			var vm = this;
			let odd = {
				display: match.odd_key,
				odd_key: match.odd_key,
				odd_value: match.odd_value,
				parent_match_id: match.parent_match_id,
				special_bet_value: match.special_bet_value,
				sport_id: match.sport_id,
			};
			let bet = {
				matchId: match.match_id,
				odd,
				type: match.sub_type_id,
				market: match.name,
				display: `${match.home_team} vs ${match.away_team}`,
				startTime: match.start_time,
				live: false,
				active: true,
				is_shared: true,
				share_code: meta["code"],

				// Coola payload
				profile_id: this.$store.getters.user.id,
				app_name: "MOBILE_WEB",
				parent_match_id: match.parent_match_id,
				game_description: `${match.home_team} vs ${match.away_team}`,
				bet_pick: odd.odd_key,
				sub_type_id: match.sub_type_id,
				market_name: match.name,
				odd_key: odd.odd_key,
				odd_value: odd.odd_value,
				special_bet_value: odd.special_bet_value || "",
				bet_type: "prebet",
				home_team: match.home_team,
				away_team: match.away_team,
				sport_id: match.sport_id,
			};
			vm.$store.commit("addToJengabetBetslip", bet);
		},
	},
};
</script>

<style lang="scss" scoped>
.load-betslip {
	text-align: center;
	padding: 20px;
	background: var(--white);
	&__sharing-code {
		display: flex;
		flex-direction: column;
		width: 100%;
		&__input {
			text-align: center;
			margin-bottom: 10px;
		}
	}
	&__desc {
		margin: 0;
		margin-bottom: 10px;
		font-size: var(--font-normal);
	}
}
.error {
	display: block;
	margin-bottom: 10px;
	color: #c00;
	font-size: var(--font-small);
	width: 100%;
}
</style>
